import React from "react";
import { Col, Row } from 'react-bootstrap';
import styles from './Comments.module.css';
import Button from "../Button";

const Comments = props => {
  const { value = '', onChange, name, placeholder, buttonClick, loading = false, ...other } = props;

  return (
    <div className={styles.writeComment} {...other}>
      <Row>
        <Col>
          <textarea className={styles.textArea} value={value} onChange={onChange} name={name} placeholder={placeholder} />
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="d-flex justify-content-between align-items-center mt-2">
            <div>

            </div>
            <Button
              size="sm"
              color="secondary"
              onClick={buttonClick}
              loading={loading}
              disabled={!value}
            >
              Comentar
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default Comments 